import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/nft/nft-banner.png';
import _imports_1 from '@/assets/images/icons/mint.svg';
import _imports_2 from '@/assets/images/icons/tip-whilte.svg';
import _imports_3 from '@/assets/images/nft/num1.png';
import _imports_4 from '@/assets/images/icons/link-open-green.svg';
const _withScopeId = n => (_pushScopeId("data-v-5f80d037"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  ref: "topEl"
};
const _hoisted_2 = {
  class: "row m-0 mt-4"
};
const _hoisted_3 = {
  class: "col-12 p-0 position-relative"
};
const _hoisted_4 = {
  class: "nft-bg-content mt-4"
};
const _hoisted_5 = {
  class: "nft-bg-center"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "100%",
    "height": "100%",
    "max-width": "320px",
    "max-height": "320px",
    "border-radius": "20px"
  },
  src: _imports_0,
  class: "avt-img"
}, null, -1));
const _hoisted_7 = {
  class: "avt-content"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "desc"
};
const _hoisted_10 = {
  class: "actions"
};
const _hoisted_11 = {
  class: "d-flex align-items-center"
};
const _hoisted_12 = {
  class: "w-100 position-relative"
};
const _hoisted_13 = {
  class: "w-100 d-flex align-items-center flex-wrap",
  style: {
    "gap": "10px"
  }
};
const _hoisted_14 = {
  class: "mint-left"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "14px",
    "margin-right": "10px"
  },
  alt: ""
}, null, -1));
const _hoisted_16 = {
  key: 0,
  class: "mint-right"
};
const _hoisted_17 = {
  key: 0,
  class: "select-mint-number"
};
const _hoisted_18 = {
  class: "fs-12",
  style: {
    "color": "rgb(168, 171, 178)",
    "margin-right": "10px"
  }
};
const _hoisted_19 = {
  class: "fw-medium"
};
const _hoisted_20 = {
  key: 1,
  class: "select-mint-number-empty flex-center"
};
const _hoisted_21 = {
  key: 0,
  style: {
    "font-size": "12px",
    "position": "absolute",
    "right": "0",
    "margin-top": "3px"
  }
};
const _hoisted_22 = {
  class: "total-tip"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "18px",
    "margin-bottom": "2px",
    "cursor": "pointer"
  },
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_24 = {
  class: "content-bottom"
};
const _hoisted_25 = {
  class: "total-title"
};
const _hoisted_26 = {
  class: "value"
};
const _hoisted_27 = {
  class: "Tooltip nowrap"
};
const _hoisted_28 = {
  class: "Tooltip nowrap"
};
const _hoisted_29 = {
  class: "Tooltip-handle"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nft-bg-content-ab"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "nft-bg",
  style: {
    "background-image": "url(/images/bg/nft-banner-bg.png)"
  }
})], -1));
const _hoisted_31 = {
  class: "container mt-5",
  style: {
    "max-width": "960px!important"
  }
};
const _hoisted_32 = {
  class: "row"
};
const _hoisted_33 = {
  class: "col-12"
};
const _hoisted_34 = {
  style: {
    "margin-top": "50px"
  }
};
const _hoisted_35 = {
  class: "flex-center title"
};
const _hoisted_36 = {
  class: "flex-center mt-2"
};
const _hoisted_37 = {
  class: "referral-step-line"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-complete"
}, null, -1));
const _hoisted_40 = {
  class: "step-box"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "step-number"
}, "1", -1));
const _hoisted_42 = {
  class: "step-item"
};
const _hoisted_43 = {
  class: "step-box position-relative"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "step-number"
}, "2", -1));
const _hoisted_45 = {
  class: "step-item"
};
const _hoisted_46 = {
  class: "step-box position-relative"
};
const _hoisted_47 = {
  class: "coming-soon"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "step-number step-number-dis"
}, "3", -1));
const _hoisted_49 = {
  class: "step-item"
};
const _hoisted_50 = {
  class: "col-12"
};
const _hoisted_51 = {
  class: "panel-content"
};
const _hoisted_52 = {
  class: "row"
};
const _hoisted_53 = {
  class: "col-md-4 col-12"
};
const _hoisted_54 = {
  class: "item d-md-none d-flex justify-content-between"
};
const _hoisted_55 = {
  class: "label"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "amount"
}, "#0", -1));
const _hoisted_57 = {
  class: "col-md-4 col-12 mt-md-0 mt-2"
};
const _hoisted_58 = {
  class: "item d-md-none d-flex justify-content-between"
};
const _hoisted_59 = {
  class: "label"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "amount"
}, "0", -1));
const _hoisted_61 = {
  class: "col-md-4 col-12 mt-md-0 mt-2"
};
const _hoisted_62 = {
  class: "item d-md-none d-flex justify-content-between"
};
const _hoisted_63 = {
  class: "label"
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "amount"
}, "0", -1));
const _hoisted_65 = {
  class: "row mt-md-3 mt-0"
};
const _hoisted_66 = {
  class: "col-md-4 col-12 mt-md-0 mt-2"
};
const _hoisted_67 = {
  class: "item d-md-none d-flex justify-content-between"
};
const _hoisted_68 = {
  class: "label"
};
const _hoisted_69 = /*#__PURE__*/_createStaticVNode("<div class=\"amount\" data-v-5f80d037><div class=\"time-countdown\" data-v-5f80d037><div class=\"time-left\" data-v-5f80d037>00<span data-v-5f80d037>d </span></div><div class=\"space\" data-v-5f80d037>:</div><div class=\"time-left\" data-v-5f80d037>00<span data-v-5f80d037>h </span></div><div class=\"space\" data-v-5f80d037>:</div><div class=\"time-left\" data-v-5f80d037>00<span data-v-5f80d037>m</span></div><div class=\"space\" data-v-5f80d037>:</div><div class=\"time-left\" data-v-5f80d037>00<span data-v-5f80d037>s</span></div></div></div>", 1);
const _hoisted_70 = {
  class: "col-md-4 col-12 mt-md-0 mt-2"
};
const _hoisted_71 = {
  class: "item d-md-none d-flex justify-content-between"
};
const _hoisted_72 = {
  class: "label"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "amount"
}, "0%", -1));
const _hoisted_74 = {
  class: "col-md-4 col-12 mt-md-0 mt-2"
};
const _hoisted_75 = {
  class: "item d-md-none d-flex justify-content-between"
};
const _hoisted_76 = {
  class: "label"
};
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "amount"
}, "0", -1));
const _hoisted_78 = {
  class: "col-12",
  ref: "myNftList"
};
const _hoisted_79 = {
  class: "my-nft-content"
};
const _hoisted_80 = {
  class: "nft-tools"
};
const _hoisted_81 = {
  class: "amount-nft"
};
const _hoisted_82 = {
  class: "amount-box"
};
const _hoisted_83 = {
  class: "mr-3"
};
const _hoisted_84 = {
  class: "head-right"
};
const _hoisted_85 = {
  style: {
    "transform": "translateY(2px)",
    "margin-right": "2px"
  }
};
const _hoisted_86 = {
  key: 0,
  class: "nft-info-empty",
  "element-loading-text": "Loading..."
};
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "img-avt",
  alt: "img"
}, null, -1));
const _hoisted_88 = {
  class: "content"
};
const _hoisted_89 = {
  class: "txt-asset"
};
const _hoisted_90 = {
  class: "flex-center"
};
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "margin-left": "4px",
    "cursor": "pointer"
  },
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_92 = {
  key: 1,
  class: "nft-info",
  "element-loading-text": "Loading..."
};
const _hoisted_93 = {
  style: {
    "border-radius": "15px"
  }
};
const _hoisted_94 = {
  key: 0,
  style: {
    "min-width": "182px",
    "min-height": "184px"
  },
  "element-loading-text": "Loading..."
};
const _hoisted_95 = {
  style: {
    "min-width": "182px",
    "min-height": "182px"
  },
  "element-loading-text": "Loading..."
};
const _hoisted_96 = {
  style: {
    "min-width": "182px",
    "min-height": "182px"
  },
  class: "image-slot flex-center"
};
const _hoisted_97 = {
  class: "text-left mt-2 fsi-14"
};
const _hoisted_98 = {
  class: "fw-bold"
};
const _hoisted_99 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "5px"
  }
}, "StableJumper", -1));
const _hoisted_100 = {
  class: "mt-2 btn-stake-content"
};
const _hoisted_101 = {
  class: "col-12"
};
const _hoisted_102 = {
  class: "help-content"
};
const _hoisted_103 = {
  class: "flex-center"
};
const _hoisted_104 = {
  class: "title"
};
const _hoisted_105 = {
  class: "row",
  style: {
    "margin-top": "40px"
  }
};
const _hoisted_106 = {
  class: "col-lg-4 col-12"
};
const _hoisted_107 = {
  class: "help-item"
};
const _hoisted_108 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "help-step-number"
}, "1", -1));
const _hoisted_109 = {
  class: "step-content"
};
const _hoisted_110 = {
  class: "content"
};
const _hoisted_111 = {
  class: "howto-link",
  href: "#/referrals"
};
const _hoisted_112 = {
  class: "col-lg-4 col-12 mt-lg-0 mt-3"
};
const _hoisted_113 = {
  class: "help-item"
};
const _hoisted_114 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "help-step-number"
}, "2", -1));
const _hoisted_115 = {
  class: "step-content"
};
const _hoisted_116 = {
  class: "content"
};
const _hoisted_117 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "howto-link",
  href: "#/nft"
}, null, -1));
const _hoisted_118 = {
  class: "col-lg-4 col-12 mt-lg-0 mt-3"
};
const _hoisted_119 = {
  class: "help-item"
};
const _hoisted_120 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "help-step-number"
}, "3", -1));
const _hoisted_121 = {
  class: "step-content"
};
const _hoisted_122 = {
  class: "content"
};
const _hoisted_123 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "howto-link",
  href: "#/nft"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_Refresh = _resolveComponent("Refresh");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_icon_picture = _resolveComponent("icon-picture");
  const _component_el_image = _resolveComponent("el-image");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('nft.title')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('nft.decs')), 1), _createElementVNode("div", _hoisted_10, [!_ctx.wlMintState && _ctx.canWlMintState || !_ctx.highWlMintState && _ctx.canHighWlMintState ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [!_ctx.wlMintState && _ctx.canWlMintState ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    loading: _ctx.whiteListBtnMintLoading || $data.mintLoading,
    class: "btn btn-info i-button",
    style: {
      "border-radius": "10px!important"
    },
    onClick: $options.mintWl
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('nft.Whitelist Mint NFT')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])) : _createCommentVNode("", true), !_ctx.highWlMintState && _ctx.canHighWlMintState ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    loading: _ctx.whiteListBtnMintLoading || $data.mintLoading,
    class: "btn btn-super i-button",
    style: {
      "border-radius": "10px!important"
    },
    onClick: $options.mintHightWl
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('nft.Mint through Rare WhiteList')), 1)]),
    _: 1
  }, 8, ["loading", "onClick"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(_component_i_skeleton, {
    key: 1,
    loading: _ctx.mintBtnLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_skeleton_item, {
      class: "mint-left",
      variant: "p",
      style: {
        "width": "100%",
        "height": "50px",
        "opacity": ".2",
        "margin-right": "10px"
      }
    }), _createVNode(_component_el_skeleton_item, {
      class: "mint-right",
      variant: "p",
      style: {
        "width": "100%",
        "height": "50px",
        "opacity": ".2"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
      disabled: true,
      class: "btn btn-primary i-button w-100",
      style: {
        "border-radius": "10px!important"
      }
    }, {
      default: _withCtx(() => [_hoisted_15, _createTextVNode(_toDisplayString(_ctx.$t('nft.Coming soon')), 1)]),
      _: 1
    })]), _ctx.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_ctx.mints.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_select, {
      modelValue: $data.mintCount,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.mintCount = $event),
      size: "large",
      placeholder: "Select",
      "popper-class": "select-mint-number-item"
    }, {
      prefix: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.mints[$data.mintCount - 1].simpleLabel), 1)]),
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mints, item => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.value,
          label: item.label,
          value: item.value
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_18, _toDisplayString(item.amount), 1), _createElementVNode("span", _hoisted_19, _toDisplayString(item.label), 1)]),
          _: 2
        }, 1032, ["label", "value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])) : _createCommentVNode("", true), _ctx.mints.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Out of stock ")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _ctx.publicSale && _ctx.open ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('nft.Round End').replaceAll('$$$$', _ctx.index)) + ":" + _toDisplayString($options.simpleDateFormatByMin(_ctx.endTime)), 1)) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["loading"]))]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createTextVNode(" " + _toDisplayString(_ctx.$t('nft.All income from minting is deposited into the risk reserve fund')), 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('nft.Total Risk Reserve Value')), 1), _createElementVNode("div", _hoisted_26, [_createVNode(_component_i_skeleton, {
    loading: _ctx.treasuryBalanceLoading
  }, {
    template: _withCtx(() => [_createElementVNode("span", _hoisted_27, [_createVNode(_component_el_skeleton_item, {
      class: "Tooltip-handle",
      variant: "p",
      style: {
        "width": "100%",
        "height": "24px",
        "opacity": ".2"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString($options.formatWalletFilPrice(_ctx.treasuryBalance, 4)), 1)])]),
    _: 1
  }, 8, ["loading"])])])])])]), _hoisted_30])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('nft.Earn real profit as a Community Ambassador')), 1)]), _createElementVNode("div", _hoisted_36, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('nft.Earn Airdrop from DAO with your NFT')), 1)])]), _createElementVNode("div", _hoisted_37, [_hoisted_38, _hoisted_39, _createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('nft.Get NFT')), 1)]), _createElementVNode("div", _hoisted_43, [_hoisted_44, _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('nft.Stake NFT')), 1)]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('nft.Coming soon')), 1)]), _hoisted_48, _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('nft.Earn reward')), 1)])])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('nft.Current epoch')), 1), _hoisted_56])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('nft.Staked NFT')), 1), _hoisted_60])]), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('nft.Total distributed')), 1), _hoisted_64])])]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('nft.Next epoch')), 1), _hoisted_69])]), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('nft.Max APR')), 1), _hoisted_73])]), _createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$t('nft.Next epoch reward')), 1), _hoisted_77])])])])]), _createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createTextVNode(_toDisplayString(_ctx.$t('nft.Your Nft')) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.nftList.length > 0 ? _ctx.nftList.length : '--'), 1)]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('nft.Your staked NFT')) + ":" + _toDisplayString(_ctx.myStakeNftListTotal > 0 ? _ctx.myStakeNftListTotal : '--'), 1)])]), _createElementVNode("div", _hoisted_84, [_ctx.isConnected ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "link-text flex-center refresh-code",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.refresh && $options.refresh(...args))
  }, [_createElementVNode("span", _hoisted_85, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Refresh)]),
    _: 1
  })]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('Referrals.refresh')), 1)])) : _createCommentVNode("", true)])]), _ctx.nftList === null || _ctx.nftList.length === 0 ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_86, [_hoisted_87, _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.$t('nft.You dont have any StableJumper NFTs')), 1), _createElementVNode("div", _hoisted_90, [_createElementVNode("span", {
    class: "txt-link cursor-pointer",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goToTop && $options.goToTop(...args))
  }, _toDisplayString(_ctx.$t('nft.Get Your StableJumper NFTs')), 1), _hoisted_91])])])), [[_directive_loading, _ctx.myNftListLoading || _ctx.myStakeNftListLoading]]) : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_92, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nftList, (nft, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["nft-info-item", parseInt(nft.power) >= 1500 ? 'nft-info-item-super' : '']),
      key: index,
      style: {
        "border-radius": "15px",
        "padding": "13px",
        "box-shadow": "0px 6px 24px 0px rgba(21,42,149,0.12)"
      }
    }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_93, [nft.img === '' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_94, null, 512)), [[_directive_loading, true]]) : _createCommentVNode("", true), nft.img !== '' ? (_openBlock(), _createBlock(_component_el_image, {
      key: 1,
      style: {
        "min-width": "182px",
        "min-height": "182px"
      },
      class: "nft-info-image",
      src: nft.img
    }, {
      placeholder: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_95, null, 512), [[_directive_loading, true]])]),
      error: _withCtx(() => [_createElementVNode("div", _hoisted_96, [_createVNode(_component_el_icon, {
        szie: "50"
      }, {
        default: _withCtx(() => [_createVNode(_component_icon_picture, {
          szie: "50"
        })]),
        _: 1
      })])]),
      _: 2
    }, 1032, ["src"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_97, [_createElementVNode("div", _hoisted_98, [_hoisted_99, _createTextVNode(" #" + _toDisplayString(nft.tokenId), 1)]), _createElementVNode("div", null, [_createTextVNode(" Power: "), _createElementVNode("span", {
      style: _normalizeStyle({
        color: nft.power >= 1500 ? 'rgb(239,80,27)' : '#6752f0'
      })
    }, _toDisplayString(nft.power), 5)]), _createElementVNode("div", _hoisted_100, [nft.isStake ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      class: "btn btn-info i-sm-button w-100",
      loading: $data.stakeLoading,
      onClick: $event => $options.unStakeNft(nft.tokenId),
      style: {
        "border-radius": "10px !important"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('nft.unStake')), 1)]),
      _: 2
    }, 1032, ["loading", "onClick"])) : _createCommentVNode("", true), !nft.isStake ? (_openBlock(), _createBlock(_component_el_button, {
      key: 1,
      class: "btn btn-stake i-sm-button w-100",
      loading: $data.stakeLoading,
      onClick: $event => $options.stakeNft(nft.tokenId),
      style: {
        "border-radius": "10px !important"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('nft.stake')), 1)]),
      _: 2
    }, 1032, ["loading", "onClick"])) : _createCommentVNode("", true)])])], 2);
  }), 128))])), [[_directive_loading, _ctx.myNftListLoading || _ctx.myStakeNftListLoading]])])], 512), _createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, [_createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.$t('nft.How to get reward with StableJumper NFTs')), 1)]), _createElementVNode("div", _hoisted_105, [_createElementVNode("div", _hoisted_106, [_createElementVNode("div", _hoisted_107, [_hoisted_108, _createElementVNode("div", _hoisted_109, [_createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.$t('nft.By referring a staker to join you can get it for free')), 1), _createElementVNode("a", _hoisted_111, _toDisplayString(_ctx.$t('nft.Referral now')), 1)])])]), _createElementVNode("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [_hoisted_114, _createElementVNode("div", _hoisted_115, [_createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.$t('nft.Stake your NFT to earn rewards from STFIL DAO Tokens')), 1), _hoisted_117])])]), _createElementVNode("div", _hoisted_118, [_createElementVNode("div", _hoisted_119, [_hoisted_120, _createElementVNode("div", _hoisted_121, [_createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.$t('nft.The longer you stake the higher rewards you earn from STFIL DAO')), 1), _hoisted_123])])])])])])])])], 512);
}